module.exports = new __parcel__URL__("search-no-results-old-darkmode.41158025.svg").toString();